<template>
    <div class="w-100 d-flex align-items-center">
        <template v-if="!isEditPassword">
            <div class="w-100 text-center">
                <button type="button"
                        class="btn btn-outline-dark text-uppercase btn-sm"
                        @click="openEditPassword">
                    {{$ml.get('ChangePassword')}}
                </button>
            </div>
        </template>
        <form v-else
              class="w-100"
              @submit.prevent="editPassword">
            <div class="form-row align-items-center px-3">
                <div class="col flex-grow-0 qf-no-wrap">
                    {{$ml.get('ChangePassword')}}
                </div>
                <div class="col flex-grow-1">
                    <input v-validate="'required|min:6'"
                           type="password"
                           class="form-control form-control-sm"
                           name="password"
                           :class="{'is-invalid': errors.has('password')}"
                           v-model="password"
                           :placeholder="$ml.get('password')"
                           ref="password"/>
                </div>
                <div class="col flex-grow-1">
                    <input type="password"
                           class="form-control form-control-sm"
                           name="confirm_password"
                           v-validate="'required|confirmed:password|min:6'"
                           :class="{'is-invalid': errors.has('confirm_password')}"
                           v-model="confirm_password"
                           :placeholder="$ml.get('confirm_password')"
                           data-vv-as="password"/>
                </div>
                <div class="col flex-grow-0 text-right">
                    <button class="btn btn-warning btn-sm btn-fixed-width"
                            type="submit"
                            :disabled="loading">
                        <font-awesome-icon icon="spinner" class="fa-spin" v-if="loading"/>
                        <font-awesome-icon icon="save" v-else/>
                    </button>
                </div>
                <div class="col flex-grow-0 text-right">
                    <button class="btn btn-outline-dark btn-sm btn-fixed-width"
                            @click="closeEditPassword"
                            :disabled="loading">
                        <font-awesome-icon icon="times"/>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: "EditPasswordForm",
        data() {
            return {
                password: '',
                confirm_password: '',
                isEditPassword: false,
                loading: false
            }
        },
        methods: {
            emptyForm() {
                this.password = null;
                this.confirm_password = null;
            },
            openEditPassword() {
                this.isEditPassword = true;
            },
            closeEditPassword() {
                this.isEditPassword = false;
                this.emptyForm();
                this.$validator.reset();
            },
            editPassword() {
                if (!this.loading) {
                    this.$validator.validateAll().then((result) => {
                        if (result) {
                            this.loading = true;
                            let data = {
                                access_token: localStorage.getItem('user-token'),
                                password: this.password,
                                confirm_password: this.confirm_password
                            };
                            this.$store.dispatch('changePassword', data).then(() => {
                                this.closeEditPassword();
                                this.loading = false;
                            }).catch(error => {
                                if (error.status === 400) {
                                    error.data.forEach(obj => {
                                        this.errorMessages.password = obj.message;
                                    });
                                }
                                this.loading = false;
                            })
                        }
                    });
                }
            }
        }
    }
</script>

<style scoped>
    .qf-change-password-wrapper input {
        min-width: 200px;
    }

    .qf-change-password-wrapper .alert-danger {
        max-width: 300px;
        margin: 5px auto 10px;
    }

    .qf-change-password-wrapper button {
        min-width: 80px;
        width: 80px;
        padding: 3px 10px;
        font-size: 1em;
        font-weight: 500;
    }
</style>
